module.exports = __webpack_public_path__ + "static/media/logo-horizontal-color.425ca312.svg";